module.exports = __webpack_public_path__ + "static/toggl-plan-poster-f25a1abe81e0825d3dab2065026b15fc.png";